import { useCallback, useState } from "react";
import CustomersService from "../../../../../../../../../../../services/customers";
import { EMAIL_RULE } from "../../../../../../../../../../../lib/validationRules";

export const useFetchEmailReciever = (
  setData: React.Dispatch<React.SetStateAction<any[]>>,
  setSendToValues: React.Dispatch<React.SetStateAction<any[] | undefined>>
) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const search = useCallback(
    (num: number) => {
      setIsLoading(true);

      CustomersService.searchByNumber(num)
        .then((searchResult) => {
          CustomersService.emailPreferences(searchResult.id)
            .then((emailPrefs) => {
              setData((prev: any) => {
                const val = [...prev];

                if (emailPrefs.primaryEmail) {
                  val.push({
                    name: searchResult.name,
                    number: num,
                    value: emailPrefs.primaryEmail,
                    email: emailPrefs.primaryEmail,
                    type: "Primary email",
                    id: searchResult.id
                  });

                  emailPrefs.isPrimaryEmailForReceiving &&
                    setSendToValues((prev) => [...(prev ?? []), emailPrefs.primaryEmail]);
                }

                if (emailPrefs.alternativeEmail && emailPrefs.alternativeEmail !== emailPrefs.primaryEmail) {
                  val.push({
                    name: searchResult.name,
                    number: num,
                    value: emailPrefs.alternativeEmail,
                    email: emailPrefs.alternativeEmail,
                    type: "Alternate email",
                    id: searchResult.id
                  });

                  emailPrefs.isAlternateEmailForReceiving &&
                    setSendToValues((prev) => [...(prev ?? []), emailPrefs.alternativeEmail]);
                }

                return val;
              });
              setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
        })
        .catch(() => setIsLoading(false));
    },
    [setData, setSendToValues]
  );

  const testEmail = useCallback(
    (val: string) => {
      if (EMAIL_RULE.test(val)) {
        setData((prev: any) => {
          const value = [...prev];

          value.push({ email: val, name: val, value: val, isEmail: true });

          return value;
        });
      }
    },
    [setData]
  );

  return { isLoading, search, testEmail };
};
